module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?9bfeb985a91e5545d78b906676d8e6fb";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.ttf?v=4.5.95
// module id = FlwN
// module chunks = 1